"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _priceFormat = _interopRequireDefault(require("../priceFormat"));
var totalPrice = function totalPrice(price, amount) {
  return (0, _priceFormat["default"])(price * amount);
};
var _default = totalPrice;
exports["default"] = _default;